import React from 'react'
import { Typography } from '@mui/material'
import {
  Page,
  Section,
  Bullets,
  Bullet,
  Info,
} from '../../components/DocsComponents.jsx'
import DocLink from '../../components/DocLink.jsx'

const FinanceKPIs = () => (
  <Page
    title="Finance KPIs"
    intro="The KPI dashboard has a Finance section that tracks revenue, event costs and
    margin, outstanding and overdue balances, quote pipeline, and aged debt — alongside
    the clinical and operational KPI sections."
  >
    <Section title="Where to find it">
      <Typography>
        Open the KPI dashboard at <DocLink url="/kpi" text="KPIs" /> and choose
        the <strong>Finance</strong> section (
        <DocLink url="/kpi/finance" text="/kpi/finance" />
        ). How the dashboard itself works — reporting periods, targets, and
        drill-downs — is covered in{' '}
        <DocLink
          url="/clinical-governance/kpi-tracker"
          text="KPI Tracker"
          docsPage
        />
        .
      </Typography>
    </Section>

    <Section title="What it measures">
      <Bullets>
        <Bullet>
          <strong>Revenue Invoiced</strong> — total invoiced across Events and
          PTS in the selected period.
        </Bullet>
        <Bullet>
          <strong>Event Costs (est.)</strong> — estimated staff, vehicle,
          consumables, and expense cost across events in the period.
        </Bullet>
        <Bullet>
          <strong>Event Margin</strong> — estimated profit margin on event work
          (event revenue minus estimated event costs), measured against your
          target.
        </Bullet>
        <Bullet>
          <strong>Outstanding Balance</strong> and{' '}
          <strong>Overdue Balance</strong> — unpaid totals across all live
          invoices.
        </Bullet>
        <Bullet>
          <strong>Quotes Expiring Soon</strong> — sent quotes (Event and PTS)
          expiring within 14 days with no response yet.
        </Bullet>
        <Bullet>
          <strong>Aging Debtors</strong> — the overdue balance broken down by
          how many days past due.
        </Bullet>
      </Bullets>
      <Info>
        Two things to read carefully: event costs are an <strong>estimate</strong>{' '}
        for margin awareness, not exact accounting (and PTS has no comparable
        cost model yet); and the debtor balances are a{' '}
        <strong>current snapshot</strong>, not bound to the selected reporting
        period.
      </Info>
    </Section>

    <Section title="Who can do this?">
      <Typography>
        Opening the Finance KPI section requires the{' '}
        <strong>Governance</strong> team role. The KPI overview page (headline
        tiles across all sections) is also available to the Manager and
        Supervisor teams.
      </Typography>
    </Section>
  </Page>
)

export default FinanceKPIs
